import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show nav when scrolling up or at the top
      if (currentScrollY < lastScrollY || currentScrollY < 50) {
        setIsVisible(true);
      } else {
        // Hide nav when scrolling down (and not at top)
        setIsVisible(false);
        setMobileMenuOpen(false); // Close mobile menu when hiding
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center overflow-hidden h-14">
            <img 
              src="/images/trueledger-logo.png" 
              alt="Trueledger" 
              className="h-20 w-auto object-cover object-bottom"
            />
          </Link>

          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/services" className="text-gray-700 hover:text-[#3E2723] transition-colors py-2">
              Services
            </Link>

            <Link to="/community" className="text-gray-700 hover:text-[#3E2723] transition-colors py-2">
              Community
            </Link>

            <Link to="/our-team" className="text-gray-700 hover:text-[#3E2723] transition-colors py-2">
              About
            </Link>

            <Link to="/pricing" className="text-gray-700 hover:text-[#3E2723] transition-colors">
              Pricing
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2 text-gray-700 hover:text-[#3E2723]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100 pt-4">
            <Link 
              to="/services" 
              className="block py-2 text-gray-700 font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Services
            </Link>

            <Link 
              to="/community" 
              className="block py-2 text-gray-700 font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Community
            </Link>

            <Link 
              to="/our-team" 
              className="block py-2 text-gray-700 font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </Link>

            <Link 
              to="/pricing" 
              className="block py-2 text-gray-700 font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Pricing
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
